<template>
  <div class="my-1" data-testid="nachweis-status">
    <v-chip x-small label class="mr-1 my-1" :color="inhalt.color" outlined>
      Beleg: {{ inhalt.text }}
    </v-chip>
    <v-chip v-if="zeigeBank" x-small label class="mr-1 my-1" :color="bank.color" outlined>
      Buchungsbeleg: {{ bank.text }}
    </v-chip>
    <div v-if="keineRechnungErforderlich" class="text-caption">
      Rechnung nicht erforderlich: {{ evidence.invoiceRequirement.reason }}
    </div>
    <div v-for="warnung in warnungen" :key="warnung" class="warning--text text-caption">
      {{ warnung }}
    </div>
    <div v-if="optionalePruefungVeraltet" class="text-caption grey--text">
      Eine frühere optionale Prüfung passt nicht mehr zum aktuellen Stand.
    </div>
  </div>
</template>

<script>
import { nachweisStatus, nachweisWarnungen } from '@/utils/nachweisStatus';

export default {
  props: {
    evidence: { type: Object, default: null },
    zeigeBank: { type: Boolean, default: true },
  },
  computed: {
    inhalt() { return nachweisStatus(this.evidence, 'content'); },
    bank() { return nachweisStatus(this.evidence, 'bank'); },
    warnungen() { return nachweisWarnungen(this.evidence); },
    optionalePruefungVeraltet() {
      return this.evidence && ['content', 'bank'].some((art) => this.evidence[art]
        && this.evidence[art].effectiveStatus === 'review_stale');
    },
    keineRechnungErforderlich() {
      const anforderung = this.evidence && this.evidence.invoiceRequirement;
      if (!anforderung || anforderung.effectiveStatus === 'review_stale') return false;
      return typeof anforderung.effectiveRequired === 'boolean'
        ? !anforderung.effectiveRequired : anforderung.status === 'not_required';
    },
  },
};
</script>
